import { ApplicationEditLayout, Content } from "core/layouts";
import PropTypes from "prop-types";
import React from "react";
import { defaultTemplate } from "core/hoc";
import { BasicInput, DatePickerField, BaasicFieldDropdown } from "core/components";

const WoundOrderEditTemplate = function( { woundOrderEditViewStore }){
    const {
        form,
        facilityStore,
        contentLoading
    } = woundOrderEditViewStore;
    return (
    <ApplicationEditLayout store={woundOrderEditViewStore}>
            <Content loading={contentLoading}>
				<div className="row">
                    <div className="col col-sml-12 col-lrg-12">
                        <div className="card card--form card--primary card--med">
                            
                            <div className="row">
								<div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                    <BasicInput field={form.$('firstName')} />
								</div>
								<div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                    <BasicInput field={form.$('lastName')} />
								</div>
                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
									<DatePickerField field={form.$('dateOfBirth')} />
								</div>
                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                    <BaasicFieldDropdown field={form.$('facilityId')} store={facilityStore}/>
                                </div>
							</div>
                            
                            <div className="row">
                            <div className="form__group col col-lrg-6 u-mar--bottom--sml">
									<DatePickerField field={form.$('dateOfService')} />
								</div>
                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
									<DatePickerField field={form.$('assessmentDate')} />
								</div>
                            </div>
						</div>
					</div>
				</div>
			</Content>
        </ApplicationEditLayout>
    )
};

WoundOrderEditTemplate.propTypes = {
    woundOrderEditViewStore: PropTypes.object.isRequired,
    t: PropTypes.func
};

export default defaultTemplate(WoundOrderEditTemplate);